'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export interface SpotlightProps {
  className?: string;
  size?: number;
  children?: React.ReactNode;
}

/**
 * A simplified spotlight component that renders its children
 * without the spotlight effect to avoid TypeScript errors.
 */
export function Spotlight({
  className,
  children,
}: SpotlightProps) {
  return React.createElement(
    'div',
    { className: cn('relative', className) },
    children
  );
}
